import React from "react";
import "./AboutMe.css";
import emoji from "../../assets/my-emoji.png";

function AboutMe() {
  return (
    <div className="AboutMe">
      <div className="AboutMe_top">
        <h3 className="heading heading--3">Hello I'm</h3>
        <h1 className="heading heading--1">Raymond.</h1>
        <br />
      </div>
      <p className="paragraph paragraph--1">
        I am a
        <span className="heading heading--3"> Senior Fullstack Engineer</span>
        <br />
        based in Derby, Kansas, US.
        <br />
        Interests of mine include discgolf, music and coffee. I also have a
        strong passion for coding and web3.
      </p>
      <img className="AboutMe_emoji" src={emoji} />
      <a
        href="https://drive.google.com/file/d/1C0MHbnnCo-YLIjoKODRumbfYGrmgFeP3/view?usp=sharing"
        target="_blank"
        rel="noreferrer"
      >
        <button className="button resume-button paragraph--2">Resume</button>
      </a>
    </div>
  );
}

export default AboutMe;
